export default __webpack_public_path__ + "static/media/73.ce3903eb.png";